import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Video, UserPlus, BarChart3 } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ModuleManager } from './ModuleManager';
import { AssignmentCreator } from './AssignmentCreator';
import { ProgressDashboard } from './ProgressDashboard';
import { useAuth } from '@/contexts/AuthContext';

export const AdminTrainingPanel: React.FC = () => {
  const { isAdmin } = useAuth();
  const [activeTab, setActiveTab] = useState('cursos');

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-br from-emerald-500/10 to-emerald-600/10 backdrop-blur-xl rounded-2xl p-6 border border-emerald-500/20"
    >
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className={`grid w-full ${isAdmin ? 'grid-cols-3' : 'grid-cols-2'} bg-white/5 border border-white/10 h-10 p-1 rounded-lg mb-6`}>
          <TabsTrigger
            value="cursos"
            className="data-[state=active]:bg-emerald-500/20 data-[state=active]:text-emerald-400 text-white/60 rounded text-sm"
          >
            <Video className="w-4 h-4 mr-1.5" />
            Cursos
          </TabsTrigger>
          {isAdmin && (
            <TabsTrigger
              value="asignar"
              className="data-[state=active]:bg-blue-500/20 data-[state=active]:text-blue-400 text-white/60 rounded text-sm"
            >
              <UserPlus className="w-4 h-4 mr-1.5" />
              Asignar
            </TabsTrigger>
          )}
          <TabsTrigger
            value="progreso"
            className="data-[state=active]:bg-purple-500/20 data-[state=active]:text-purple-400 text-white/60 rounded text-sm"
          >
            <BarChart3 className="w-4 h-4 mr-1.5" />
            Progreso
          </TabsTrigger>
        </TabsList>

        <TabsContent value="cursos">
          <ModuleManager />
        </TabsContent>

        {isAdmin && (
          <TabsContent value="asignar">
            <AssignmentCreator />
          </TabsContent>
        )}

        <TabsContent value="progreso">
          <ProgressDashboard />
        </TabsContent>
      </Tabs>
    </motion.div>
  );
};
